import _regenerator from "@babel/runtime/helpers/esm/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { useState } from 'react';
import { showFlashAlert } from "../../components/FlashAlert/index.js";
import t from 'format-message';
export var EXPORT_NOT_STARTED = 'EXPORT_NOT_STARTED';
export var EXPORT_PENDING = 'EXPORT_PENDING';
export var EXPORT_COMPLETE = 'EXPORT_COMPLETE';
export var EXPORT_FAILED = 'EXPORT_FAILED';
export default function useCSVExport(_ref) {
  var csvExportHandler = _ref.csvExportHandler;
  var _useState = useState(EXPORT_NOT_STARTED),
    _useState2 = _slicedToArray(_useState, 2),
    exportState = _useState2[0],
    setExportState = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    exportData = _useState4[0],
    setExportData = _useState4[1];
  var exportGradebook = function exportGradebook() {
    ;
    _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var csvExportResults, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            _context.p = 0;
            setExportState(EXPORT_PENDING);
            _context.n = 1;
            return csvExportHandler();
          case 1:
            csvExportResults = _context.v;
            setExportData(csvExportResults);
            setExportState(EXPORT_COMPLETE);
            _context.n = 3;
            break;
          case 2:
            _context.p = 2;
            _t = _context.v;
            setExportData([]);
            setExportState(EXPORT_FAILED);
            showFlashAlert({
              message: t('Error exporting gradebook'),
              type: 'error'
            });
          case 3:
            return _context.a(2);
        }
      }, _callee, null, [[0, 2]]);
    }))();
  };
  return {
    exportGradebook: exportGradebook,
    exportState: exportState,
    exportData: exportData
  };
}